export const stageOfLife = [
  {
    id: 1,
    value: 'STUDYING',
    label: 'Studying',
  },
  {
    id: 2,
    value: 'WORKING',
    label: 'Working',
  },
  {
    id: 3,
    value: 'NS',
    label: 'Full-Time National Service',
  },
  {
    id: 4,
    value: 'RETIRED',
    label: 'Retired',
  },
  {
    id: 5,
    value: 'OTHERS',
    label: 'Others',
  },
];

/**
 * Mapping from stageOfLife enum values to phaseId from the phase table
 */
export const STAGE_OF_LIFE_TO_PHASE_ID = {
  STUDYING: 1,
  WORKING: 2,
  NS: 3,
  RETIRED: 4,
  OTHERS: 5,
};
